import { useEffect, useState } from 'react';
import type { DropdownOption } from '../text-dropdown';

export interface UseDropdownStateOptions {
  value?: string;
  initialValue?: string;
  options: DropdownOption[];
  skipDisplayValueSync?: boolean;
}

interface UseDropdownStateType {
  displayedValue: string;
  setDisplayedValue: (value: string) => void;
  localValue: string;
  setLocalValue: (value: string) => void;
  focused: boolean;
  setFocused: (focused: boolean) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

function getOptionLabel(value: string, options: DropdownOption[]): string {
  const option = options.find((opt) => opt.value === value);
  return option ? option.label : value;
}

export function useDropdownState({
  value,
  initialValue,
  options,
  skipDisplayValueSync = false
}: UseDropdownStateOptions): UseDropdownStateType {
  const [focused, setFocused] = useState(false);
  const [open, setOpen] = useState(false);
  const [displayedValue, setDisplayedValue] = useState(
    value || initialValue || ''
  );
  const [localValue, setLocalValue] = useState(value || initialValue || '');

  useEffect(() => {
    if (value === undefined) {
      return;
    }

    setLocalValue(value);

    if (!skipDisplayValueSync) {
      setDisplayedValue(getOptionLabel(value, options));
    }
  }, [value, options, skipDisplayValueSync]);

  return {
    displayedValue,
    setDisplayedValue,
    localValue,
    setLocalValue,
    focused,
    setFocused,
    open,
    setOpen
  };
}
